import { render, staticRenderFns } from "./UISwitch.vue?vue&type=template&id=6d6da856&scoped=true"
import script from "./UISwitch.vue?vue&type=script&lang=js"
export * from "./UISwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6da856",
  null
  
)

export default component.exports